var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowderTransferBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.5,323.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.7,351.5c-20.5-0.1-41.4-1.8-61.9-5c-1.1-0.2-1.9-1.1-1.9-2.1v-63.5H95c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2h17.5 L11.4,33.5C9.4,29,9.9,24,12.7,19.9c2.7-4.1,7.3-6.5,12.1-6.5h310.5c4.9,0,9.4,2.4,12,6.4c2.7,4,3.1,9.1,1.3,13.5L246.3,276.5H265 c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2h-19.9v63.5c0,1-0.8,2-1.9,2.1c-21.2,3.3-42.6,5-63.7,5H177.7z M118.2,342.5l2.6,0.4 c18.7,2.7,37.9,4.1,56.9,4.2c0.7,0,1.3,0,2,0c19.5,0,39.1-1.4,58.3-4.2l2.6-0.4v-61.6H118.2V342.5z M24.8,17.7 c-3.4,0-6.5,1.6-8.5,4.5c-2,2.9-2.3,6.3-1,9.6l101.9,244.8h124.5L344.6,31.8c1.4-3.1,1-6.6-0.8-9.5c-1.9-2.9-5-4.6-8.4-4.6H24.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowderTransferBag);
export default __webpack_public_path__ + "static/media/powderTransferBag.ff8b730061ce89a5020cfd87e0ab1d87.svg";
export { ForwardRef as ReactComponent };